import { render, staticRenderFns } from "./InsClause1.vue?vue&type=template&id=deb2a08c&scoped=true"
import script from "./InsClause1.vue?vue&type=script&lang=js"
export * from "./InsClause1.vue?vue&type=script&lang=js"
import style0 from "./InsClause1.vue?vue&type=style&index=0&id=deb2a08c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "deb2a08c",
  null
  
)

export default component.exports